import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { InfoBox } from '../info-box';
import { IconNext } from '../../icons/next';
import { InfoBoxItem } from '../info-box-parts';
import { Text } from '../../text/text';

export const InfoBoxPortfolioValue: React.FC = () => {
    const { t } = useTranslation();

    return (
        <InfoBox
            image={'/images/info-box/portfolio-value.png'}
            name={t('infoBox.portfolioValue.name')}
            more={t('infoBox.portfolioValue.more')}
            description={<Trans i18nKey="infoBox.portfolioValue.description" components={{ strong: <strong /> }} />}
            extraContent={
                <>
                    <InfoBoxItem>
                        <IconNext />
                        <Text>
                            <Trans i18nKey="infoBox.portfolioValue.extra.01" components={{ strong: <strong /> }} />
                        </Text>
                    </InfoBoxItem>
                    <InfoBoxItem>
                        <IconNext />
                        <Text>
                            <Trans i18nKey="infoBox.portfolioValue.extra.02" components={{ strong: <strong /> }} />
                        </Text>
                    </InfoBoxItem>
                    <InfoBoxItem>
                        <IconNext />
                        <Text>
                            <Trans i18nKey="infoBox.portfolioValue.extra.03" components={{ strong: <strong /> }} />
                        </Text>
                    </InfoBoxItem>
                    <InfoBoxItem>
                        <IconNext />
                        <Text>
                            <Trans i18nKey="infoBox.portfolioValue.extra.04" components={{ strong: <strong /> }} />
                        </Text>
                    </InfoBoxItem>
                    <InfoBoxItem>
                        <IconNext />
                        <Text>
                            <Trans i18nKey="infoBox.portfolioValue.extra.05" components={{ strong: <strong /> }} />
                        </Text>
                    </InfoBoxItem>
                    <InfoBoxItem>
                        <IconNext />
                        <Text>
                            <Trans i18nKey="infoBox.portfolioValue.extra.06" components={{ strong: <strong /> }} />
                        </Text>
                    </InfoBoxItem>
                </>
            }
        />
    );
};
